import * as calcs from '../Formeln';

export function Einseitig(Lineargewicht, Länge, E, Iy, Verteilt, Punkt) {
  const EigenEinStarrHoch = calcs.EigenEinStarrHoch(Lineargewicht, Länge, E, Iy);

  const VertEinStarrHoch = calcs.VertEinStarrHoch(Verteilt, Länge, E, Iy);

  const PunktEinStarrHoch = calcs.PunktEinStarrHoch(Punkt, Länge, E, Iy);

  const EinStarrHochGesamt = EigenEinStarrHoch + VertEinStarrHoch + PunktEinStarrHoch;
  return Math.round(EinStarrHochGesamt * 100) / 100;
}

export function Zweisitig(Lineargewicht, Länge, E, Iy, Verteilt, Punkt, Slider) {
  const EigenAufHoch = calcs.EigenAufHoch(Lineargewicht, Länge, E, Iy);

  const VertAufHoch = calcs.VertAufHoch(Verteilt, Länge, E, Iy);

  const PunktAufHoch = calcs.PunktAufHoch(Punkt, Länge, E, Iy);

  let AufHochGesamt = EigenAufHoch + VertAufHoch + PunktAufHoch;
  AufHochGesamt = Math.round(AufHochGesamt * 100) / 100;

  const EigenZweiStarrHoch = calcs.EigenZweiStarrHoch(Lineargewicht, Länge, E, Iy);

  const VertZweiStarrHoch = calcs.VertZweiStarrHoch(Verteilt, Länge, E, Iy);

  const PunktZweiStarrHoch = calcs.PunktZweiStarrHoch(Punkt, Länge, E, Iy);

  let ZweiStarrHochGesamt = PunktZweiStarrHoch + VertZweiStarrHoch + EigenZweiStarrHoch;
  ZweiStarrHochGesamt = Math.round(ZweiStarrHochGesamt * 100) / 100;

  const erg = AufHochGesamt * (100 - Slider) * 0.01 + ZweiStarrHochGesamt * Slider * 0.01;
  return Math.round(erg * 100) / 100;
}
